export const ieo = {
  zzjx: 'đang tiến hành',
  rgjl: 'Bản ghi đăng ký',
  yjjs: 'Kết thúc rồi',
  sf: 'bản phát hành đầu tiên',
  mjze: 'tổng số tiền huy động được',
  ckjz: 'tiến trình gây quỹ',
  tips_1: 'Nền tảng Biking Startup đã ra mắt, hãy cùng Biking khám phá bí quyết làm giàu! ',
  tips_2: 'Các dự án chất lượng cao sẽ sớm được ra mắt, hãy đón chờ',
  jyjjks: 'Về để bắt đầu',
  ksjy: 'Bắt ​​đầu giao dịch',
  qjy: 'Đi giao dịch',
  xmmc: 'Tên dự án',
  xmfjs: 'Giới thiệu về bữa tiệc dự án',
  syxm: 'tất cả các dự án',
  banner_1: 'Nền tảng khởi động dự án blockchain mới ra mắt',
  banner_2: 'Đi xe đạp cùng nhau tìm kiếm con ngựa đen của blockchain và mở ra con đường dẫn đến tự do giàu có',
  ywc: 'Đã hoàn thành',
  rgsj: 'Thời gian đăng ký:',
  zcz: 'người ủng hộ',
  dqjd: 'Tiến độ hiện tại',
  yck: 'Tăng lên',
  sddb: 'Đã nhận được mã thông báo',
  dff: 'được phát hành',
  zwxm: 'Chưa có dự án nào',
  xq: 'Chi tiết',
  wksyr: 'Chưa bắt đầu làm nóng sơ bộ',
  yrz: 'làm nóng trước',
  jxz: 'đang tiến hành',
  yjs: 'Đã kết thúc',
  ts: 'nhắc nhở',
  dbwfjy: 'Mã thông báo này tạm thời không có sẵn để giao dịch',
  ckqtdb: 'Vui lòng kiểm tra các mã thông báo khác',
  xm: 'dự án',
  ksrg: 'Bắt ​​đầu đăng ký',
  yrg: 'đã đăng ký',
  xmjs: 'Giới thiệu dự án',
  csjg: 'Giá ban đầu',
  dbzl: 'Tổng số lượng token: {amount}',
  cssz: 'Giá trị thị trường ban đầu: {fdv} đô la Mỹ',
  xmcytj: 'Điều kiện tham gia dự án',
  cjygzh: 'Tạo tài khoản đi xe đạp',
  yyzh: 'Đã có tài khoản, đăng nhập trực tiếp',
  dlzhjkcy: 'Đăng nhập vào tài khoản của bạn để tham gia đăng ký',
  dljkrg: 'Đăng nhập vào tài khoản của bạn để đăng ký',
  xhzc: 'Tài sản giao ngay',
  zcdy: 'Tài sản giao ngay ≥ 10 USDT',
  rggz: 'Quy tắc đăng ký',
  rgcg: 'Đăng ký thành công',
  cgrgxm: 'Xin chúc mừng! Bạn đã đăng ký dự án thành công! ',
  fhsy: 'Quay lại trang chủ',
  cyrghd: 'Tham gia hoạt động đăng ký Khởi nghiệp đi xe đạp',
  rgje: 'số tiền đăng ký',
  xhzcgz: 'Định giá tài sản giao ngay',
  rgsm: 'Mô tả đăng ký:',
  rgsm1: '1. Số tiền đăng ký cá nhân là ≥{amount1}USDT; {amount2}USDT;',
  rgsm2: "2. Dự án phân bổ các khoản đăng ký theo tỷ lệ bằng nhau theo tỷ lệ vốn đầu tư. Nếu người dùng đăng ký mã thông báo với số tiền lớn hơn số tiền được phân bổ thực tế, sau khi hoàn tất đăng ký, số U còn lại sẽ được trả lại thành tiền mặt tài khoản",
  qd: 'Được',
  dyr: 'được làm nóng trước',
  rgdjs: 'Đếm ngược đăng ký',
  yrdjs: "Đếm ngược làm nóng trước",
  jykqdjs: 'Đếm ngược đến lúc bắt đầu giao dịch',
  qrg: 'Vào đăng ký',
  rgjebdy: 'Số tiền đăng ký ít nhất là {amount} USDT',
  rjebgy: 'Số tiền đăng ký tối đa không được vượt quá {amount} USDT',
  rgjeccdqjc: 'Số lượng đăng ký vượt quá số lượng tài sản hiện tại',
  fxts1: "1. Các dự án khởi nghiệp vẫn còn ở giai đoạn sơ khai và có thể gặp rủi ro lớn trong quá trình vận hành dự án, công nghệ cơ bản của dự án, môi trường pháp lý và quy định, v.v.",
  fxts2: "2. Hiểu về Token và đánh giá rủi ro vốn có của chúng đòi hỏi kiến ​​thức tài chính và kỹ thuật nâng cao.",
  fxts3: "3. Bị ảnh hưởng bởi công nghệ, luật pháp và quy định, thị trường và các yếu tố khác, giá Token bạn mua có thể biến động mạnh và giá có thể giảm hoặc tăng đáng kể.",
  fxts4: "4. Do công nghệ cơ bản của Token hoặc nền tảng giao dịch BIKING, Token bạn đã mua có thể không được rút toàn bộ hoặc một phần.",
  sfpt: "Nền tảng khởi động dự án Blockchain",
  xmhzsq: "Hợp tác dự án",
  hdlx: "loại",
  yryq: "một dấu hiệu",
  yrdq: "Nhiều chữ ký",
  hdjg: "Giá",
  hdsl: "Số lượng",
  zqs: "Tổng số chữ ký",
  rgqs: "Số lượng vé đăng ký",
  rgsl: "số lượng đăng ký",
  mqsl: "Số lượng trên mỗi chữ ký",
  mrzgqs: "Số lượng chữ ký cao nhất",
  qian: "ký tên",
  lian: "chuỗi",
  hdrgsm: "Hướng dẫn đăng ký: Sau khi trúng xổ số, tổng số người dùng trúng thưởng sẽ được chọn ngẫu nhiên dựa trên tất cả người dùng trúng thưởng. Nếu đăng ký không thành công, USDT đã sử dụng trong đăng ký không thành công sẽ được trả lại khi phát hành airdrop chiến thắng." ,
  jqqd: "Mong chờ kết quả chiến thắng",
  dbffkjy: "Mã thông báo có thể được giao dịch sau khi chúng được phát hành",
  dzjgb: "Sẽ được thông báo",
  dzq: "Để chiến thắng",
  ffzt: "Trạng thái phân phối",
  dbff: "Phát hành mã thông báo chiến thắng",
  yff: "Đã phát hành",
  wzq: "Không thắng",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/ieo/vi.js